import React from "react";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div className="home-hero">
      <h1 className="home-title">SmartAutomation</h1>
      <p className="home-subtitle">
        Controla el acceso a tu comunidad desde cualquier dispositivo, en cualquier lugar.
      </p>
      <div className="home-actions">
        <Link to="/login" className="btn-solid">Iniciar sesión</Link>
      </div>
      <p style={{ marginTop: 16, fontSize: 13, color: "var(--muted)" }}>
        El acceso es solo por invitación. Contacta con tu administrador.
      </p>
    </div>
  );
}
